"use strict";

require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHead = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _TableProps = require("../TableProps");
var _ColumnGroupToggle = require("./ColumnGroupToggle");
var _ColumnSortToggle = require("./ColumnSortToggle");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const TableHead = _ref => {
  let {
    headerGroups,
    hasSelectorColumn,
    enableGrouping,
    isEditable,
    inlineEditing
  } = _ref;
  const isSelectColumnHeader = (column, groupIndex, columnIndex) => {
    return column.sortedIndex === -1 && groupIndex === 0 && columnIndex === 0 && !column.isSelectorColumn && hasSelectorColumn;
  };
  const headerProps = (column, isLastColumn) => {
    const columnProps = column.getHeaderProps();
    const {
      cssClass = ''
    } = columnProps;
    return _objectSpread(_objectSpread({}, columnProps), {}, {
      className: isEditable && !inlineEditing && isLastColumn ? "".concat(cssClass, " editableControls") : cssClass
    });
  };
  return /*#__PURE__*/_react.default.createElement("thead", null, headerGroups.map((headerGroup, groupIndex) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  _react.default.createElement("tr", _extends({}, headerGroup.getHeaderGroupProps(), {
    key: "headerGroup_".concat(groupIndex)
  }), headerGroup.headers.map((column, columnIndex) => /*#__PURE__*/_react.default.createElement("th", _extends({}, headerProps(column, columnIndex === headerGroup.headers.length - 1), {
    key: "headerGroupColumn_".concat(column.id)
  }), isSelectColumnHeader(column, groupIndex, columnIndex) && 'Select', !isSelectColumnHeader(column, groupIndex, columnIndex) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "columnControls"
  }, enableGrouping && /*#__PURE__*/_react.default.createElement(_ColumnGroupToggle.ColumnGroupToggle, {
    column: column
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "tableHeaderText"
  }, column.render('Header')), column.canSort && /*#__PURE__*/_react.default.createElement(_ColumnSortToggle.ColumnSortToggle, {
    column: column
  })), column.canFilter && /*#__PURE__*/_react.default.createElement("div", {
    className: "columnFilters"
  }, column.render('Filter'))))))));
};
exports.TableHead = TableHead;
TableHead.propTypes = _TableProps.TableHeaderGroupProps;